function VolunteerPage({ onBackClick, onApplyClick }) {
    try {
        const volunteerRoles = [
            {
                title: "Technical Volunteer",
                icon: "fa-laptop-code",
                description: "Help refurbish hardware, troubleshoot systems, and maintain our computing network.",
                skills: ["Hardware repair", "Software installation", "System administration"]
            },
            {
                title: "Education Volunteer",
                icon: "fa-chalkboard-teacher",
                description: "Teach digital skills, conduct workshops, and create educational materials.",
                skills: ["Teaching", "Curriculum development", "Public speaking"]
            },
            {
                title: "Community Outreach",
                icon: "fa-hands-helping",
                description: "Engage with local communities, organize events, and build partnerships.",
                skills: ["Communication", "Event planning", "Networking"]
            },
            {
                title: "Administrative Support",
                icon: "fa-tasks",
                description: "Assist with operations, data entry, and organizational tasks.",
                skills: ["Organization", "Microsoft Office", "Time management"]
            }
        ];

        const handleBackClick = (e) => {
            e.preventDefault(); // Prevent default behavior
            if (onBackClick) onBackClick();
        };

        const handleApplyClick = (e) => {
            e.preventDefault(); // Prevent default behavior
            if (onApplyClick) onApplyClick();
        };

        return (
            <section data-name="volunteer-page" className="section bg-gray-50/50 backdrop-blur-sm">
                <div className="container max-w-5xl">
                    <button 
                        onClick={handleBackClick}
                        className="mb-8 flex items-center text-green-600 hover:text-green-500 transition-colors back-button"
                    >
                        <i className="fas fa-arrow-left mr-2"></i> Back to Home
                    </button>

                    <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-xl p-8 md:p-12">
                        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-gray-800 text-center">
                            Join Our <span className="text-green-600">Volunteer Team</span>
                        </h1>
                        
                        <div className="prose max-w-3xl mx-auto text-center mb-12">
                            <p className="text-xl text-gray-600">
                                Help us transform e-waste into opportunities by contributing your skills and time. 
                                Whether you're tech-savvy or passionate about education, we have a role for you.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                            {volunteerRoles.map((role, index) => (
                                <div 
                                    key={index}
                                    className="bg-white/80 backdrop-blur-sm rounded-xl p-6 border border-gray-200 hover:border-green-400 transition-all duration-300"
                                >
                                    <div className="flex items-start mb-4">
                                        <div className="bg-green-100 text-green-600 p-3 rounded-lg mr-4">
                                            <i className={`fas ${role.icon} text-xl`}></i>
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-800">{role.title}</h3>
                                            <p className="text-gray-600">{role.description}</p>
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <h4 className="font-semibold text-gray-700 mb-2">Useful Skills:</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {role.skills.map((skill, i) => (
                                                <span key={i} className="bg-green-50 text-green-700 text-sm px-3 py-1 rounded-full">
                                                    {skill}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="bg-blue-50/50 rounded-xl p-8 border border-blue-100 mb-12">
                            <h2 className="text-2xl font-bold mb-4 text-gray-800">Volunteer Benefits</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className="bg-white p-4 rounded-lg">
                                    <h4 className="font-bold mb-2 text-blue-600">
                                        <i className="fas fa-certificate mr-2"></i> Training
                                    </h4>
                                    <p className="text-gray-700 text-sm">
                                        Gain valuable skills in hardware refurbishment and sustainable tech
                                    </p>
                                </div>
                                <div className="bg-white p-4 rounded-lg">
                                    <h4 className="font-bold mb-2 text-blue-600">
                                        <i className="fas fa-users mr-2"></i> Community
                                    </h4>
                                    <p className="text-gray-700 text-sm">
                                        Join a network of like-minded individuals passionate about tech for good
                                    </p>
                                </div>
                                <div className="bg-white p-4 rounded-lg">
                                    <h4 className="font-bold mb-2 text-blue-600">
                                        <i className="fas fa-handshake mr-2"></i> References
                                    </h4>
                                    <p className="text-gray-700 text-sm">
                                        Earn professional references and recommendations
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="text-center">
                            <h2 className="text-2xl font-bold mb-6 text-gray-800">Ready to Volunteer?</h2>
                            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                                Complete our volunteer application form to get started.
                            </p>
                            <button
                                onClick={handleApplyClick}
                                className="btn btn-primary inline-flex items-center mx-auto"
                            >
                                <i className="fas fa-user-plus mr-2"></i>
                                Apply Now
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        );
    } catch (error) {
        console.error('VolunteerPage error:', error);
        reportError(error);
        return null;
    }
}

export default VolunteerPage;
